import fetch from '../utils/fetch';

export default email => fetch('/core/api/checkloginId', {
  method: 'post',
  body: JSON.stringify({ LoginId: email })
}).then(
  ({ exists, userRequiresNewPassword, preferredIdp, idpParameters }) =>
    ({ exists, userRequiresNewPassword, preferredIdp, idpParameters })
);
